export default __webpack_public_path__ + "static/media/nbt.24f3324a.js";